var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_10883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8561 15.9955C20.6833 15.7828 20.3932 15.7042 20.1381 15.7957C19.4225 16.0523 18.6464 16.1837 17.8288 16.1837C13.9178 16.1837 10.737 13.0012 10.737 9.09185C10.737 6.73864 11.8987 4.54783 13.8445 3.23019C14.0649 3.0807 14.1709 2.81113 14.1112 2.55204C14.052 2.29294 13.8392 2.09671 13.5749 2.05802C13.2731 2.0141 12.9729 2 12.6711 2C7.33771 2 3 6.33771 3 11.6707C3 17.0037 7.33771 21.3414 12.6707 21.3414C16.0554 21.3414 19.1348 19.6212 20.9049 16.7406C21.0479 16.5073 21.0274 16.2095 20.8557 15.9951L20.8561 15.9955Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_10883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19.3414,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoon);
export default __webpack_public_path__ + "static/media/icon-moon.f7ae6556f3549ca9dc55e04c445f9dd4.svg";
export { ForwardRef as ReactComponent };